import { Stack } from "@mui/material";
import Iconify from "src/components/Iconify";
import { Button } from "src/@/components/ui/button";
import { Switch } from "src/@/components/ui/switch";

export default function HeaderPageComponentConfig({
    titulo,
    descricao,
    actions,
    back,
    backAction,
    onSalvar,
    onExcluir,
    statusAtivo,
    onStatusChange
}) {
    return (
        <Stack justifyContent={'space-between'} alignItems={'center'} direction={'row'} className="border-slate-100 border-b pb-4 flex-wrap gap-4">
            <Stack alignItems={'center'} direction={'row'} spacing={3} className="flex-1 min-w-0">
                {backAction && (
                    <Button size="icon" variant="ghost" onClick={backAction}>
                        <Iconify icon={'material-symbols:arrow-back-ios'} />
                    </Button>
                )}
                <Stack direction={'column'} className="min-w-0">
                    <h4 className="scroll-m-20 text-xl font-semibold tracking-tight">
                        {titulo}
                    </h4>
                    <p className="text-xs leading-7">
                        {descricao}
                    </p>
                </Stack>
            </Stack>
            <div className="flex-shrink-0">
                {actions}
            </div>
            {/* <Stack direction="row" alignItems="center" spacing={2}>
                <div className="flex items-center gap-2">
                    <span className="text-xs text-gray-600">Ativo</span>
                    <Switch checked={statusAtivo} onCheckedChange={onStatusChange} />
                </div>
                <Button variant="destructive" onClick={onExcluir} size="sm">
                    <Iconify icon="material-symbols:delete-outline" className="mr-1" /> Excluir
                </Button>
                <Button variant="default" onClick={onSalvar} size="sm">
                    <Iconify icon="material-symbols:save" className="mr-1" /> Salvar
                </Button>
            </Stack> */}
        </Stack>
    );
}
